import * as React from "react";

export const PrivacyEN = () => {
  return (
    <div className="pt-4">
      {" "}
      <h2>Your privacy</h2>
      The CAK handles your personal data with care. We only use your data to assess your application. Find out
      more about <a href="https://www.hetcak.nl/en/your-privacy">your privacy</a>.
    </div>
  );
};
